import script from "./Hero.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hero.vue?vue&type=script&setup=true&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=39f35366&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f35366"]])

export default __exports__